<template>
  <div id="basic_insert">
    <div class="top_div_insert">
      <div class="top_div_insertsx">
        <el-form
          label-width="120px"
          v-loading="listloading"
          :label-position="labelPosition"
          :model="datalist"
          ref="datalist"
          :rules="rules"
        >
          <el-form-item label="联系人" prop="name">
            <el-input class="inpit_insert" v-model="datalist.name"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-radio v-model="datalist.gender" label="男">男</el-radio>
            <el-radio v-model="datalist.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="手机" prop="mobile">
            <el-input class="inpit_insert" v-model="datalist.mobile"></el-input>
          </el-form-item>
          <el-form-item label="员工卡" prop="card">
            <el-input class="inpit_insert" type="number" v-model="datalist.card"></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-select v-model="datalist.position" placeholder="请选择">
              <el-option
                v-for="(item) in listPositions"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="datalist.status" placeholder="请选择">
              <el-option
                v-for="(item) in listStatus"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="large">
            <el-button @click="gobasic_insert">取消</el-button>
            <el-button type="primary" @click="submitForm('datalist')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="img_class_insert">
        <el-upload
          :action="'https://upload-z2.qiniup.com'"
          list-type="picture-card"
          :auto-upload="true"
          :file-list="fileList"
          :on-success="topSuccess"
          :on-error="topSuccess"
          :before-upload="QiniuToken"
          :data="QiniuData"
          :limit="1"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var testPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          return callback(new Error('手机号码有误，请重新填写'));
        } else {
          callback();
        }
      }
    };
    var testName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能为空'));
      } else {
        if (!/^[\u2E80-\u9FFF_a-zA-Z]+$/.test(value)) {
          return callback(new Error('只允许包含汉字与英文字母'));
        } else {
          callback();
        }
      }
    };
    return {
      labelPosition: 'right',
      listloading: false,
      listPositions: [],
      datalist: {
        gender: null,
        name: null,
        images: [],
        leave_time: null,
        mobile: null,
        position: null,
        gender: '男',
        card:null
      },
      listStatus: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [],
      rules: {
        name: [
          { required: true, validator: testName, trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        card:[
          { required: true, message: '员工卡号不能为空', trigger: 'change' },
        ],
        gender: [
          { required: true, message: '性别不能为空', trigger: 'change' },
        ],
        mobile: [{ required: true, validator: testPhone, trigger: 'blur' }],

        position: [
          {
            required: true,
            message: '职位不能为空',
            trigger: 'change',
          },
        ],
        status: [
          {
            required: true,
            message: '状态不能为空',
            trigger: 'change',
          },
        ],
      },
      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
      //  url: this.$getStorageUrl(event.data.key),
      //     name: event.data.key,
    };
  },
  methods: {
    async QiniuToken() {
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then(res => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
    getList() {
      // this.listloading = true;
      const id = this.$route.params.id;
      const url = this.$userList.user_semployee_new + '/' + id;
      this.$http.get(url).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          this.fileList = [{ url: res.data.image, name: res.data.image }];
          this.datalist = res.data;
        } else {
          //res.message && this.$alert(res.message);
        }
        console.log(this.datalist, '????');
      });
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => {
        if (item.name !== file.name) {
          return item;
        }
      });
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      console.log(fileList);
      this.fileList = fileList.map(item => {
        if (item.response) {
          item.name = item.response.hash;
        }
        return item;
      });
    },
    submitForm(formName) {
      console.log(this.fileList.map(item => item.name));
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.params.id) {
            this.putList();
          } else {
            this.setList();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    gobasic_insert() {
      this.$router.go(-1);
    },
    getPositions() {
      const url = this.$userList.user_common_data + `/employee_position`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.listPositions = res.data.map(item => {
            item.name = item.value;
            return item;
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    getStatus() {
      // this.listloading = true;
      const url = this.$userList.user_common_data + `/employee_status`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.listStatus = res.data.map(item => {
            item.name = item.value;
            return item;
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    async setList() {
      const { gender, name, mobile, position, status,card } = this.datalist;
      const images = this.fileList.map(
        item => this.QiniuData.url_prefix + '/' + item.name
      );
      var newSet = new Set(images);
      const shop_id = +this.$route.query.shop_id;
      let data = {
        gender,
        name,
        image: [...newSet].join(''),
        mobile,
        position,
        status,
        shop_id,
        card:+card
      };

      this.$http.post(this.$userList.user_semployee_new, data).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success',
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
           if (res.code === 300) {
            res.message && this.$alert(res.message);
          }else{
            this.$alert('修改失败');
          }
        }
      });
    },
    async putList() {
      const { gender, name, mobile, position, status,card } = this.datalist;
      const images = this.fileList.map(
        item =>
          (this.QiniuData.url_prefix &&
            this.QiniuData.url_prefix + '/' + item.name) ||
          item.name
      );
      var newSet = new Set(images);
      const shop_id = +this.$route.query.shop_id;
      let data = {
        id: this.datalist.id,
        gender,
        name,
        image: [...newSet].join(''),
        mobile,
        position,
        status,
        shop_id,
        card:+card
      };

      this.$http.put(this.$userList.user_semployee_new, data).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          if (res.code === 300) {
            res.message && this.$alert(res.message);
          }else{
            this.$alert('修改失败');
          }
        }
      });
    },
  },
  created() {
    this.$root.setheadName();
    this.getPositions();
    this.getStatus();

    if (this.$route.params.id) {
      this.getList();
    }
  },
};
</script>

<style >
#basic_insert {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div_insertsx {
  width: auto;
}
.top_div_insert {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  min-height: 200px;
  display: flex;
  justify-content: center;
}
.img_class_insert {
  width: 100px;
  height: 100px;
  overflow: hidden;
  margin-left: 20px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
  input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
</style>
